import { render, staticRenderFns } from "./PetRow.vue?vue&type=template&id=00e06d2c&scoped=true&"
import script from "./PetRow.vue?vue&type=script&lang=js&"
export * from "./PetRow.vue?vue&type=script&lang=js&"
import style0 from "./PetRow.vue?vue&type=style&index=0&id=00e06d2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e06d2c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VCol,VIcon,VRow})
